/**
 * Centralizes Clerk routing configuration derived from environment variables.
 */

const clerkDisabled = process.env.NEXT_PUBLIC_DISABLE_CLERK === "1";

export const clerkPublishableKey = clerkDisabled
  ? ""
  : (process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY ?? "");

export const clerkSignInUrl = "/sign-in";
export const clerkSignUpUrl = "/sign-up";

// Centralized paths for account and sign-out handling
export const clerkAccountUrl = "/account";
export const clerkAfterSignOutUrl = "/";
